import { defineAsyncComponent } from 'vue'

export const BaseError = defineAsyncComponent(() => import('./BaseError.vue'))
